<template>
  <div class="formcontainer bg-primary text-white">
    <div class="my-8">
      <v-img
        width="100"
        max-height="40"
        contain
        :src="require('@/assets/logo/logo-white.svg')"
      ></v-img>
      <h2 class="text-white">Stix</h2>
    </div>
    <div v-if="success">
      <h1 class="text-white">Your signup has been received!</h1>
      <p style="max-width: 400px" class="text-white mt-2">
        As soon as we have reviewed your application and there is space to
        onboard your team, we will reachout automatically. Just keep an eye on
        your inbox, and we'll meet soon!
      </p>
    </div>
    <div class="center" v-if="!success">
      <h1 style="font-weight: 500; font-size: 30px" class="text-white mb-2">
        Beta - Waiting List
      </h1>
      <p class="text-white mb-8" style="max-width: 400px; font-size: 10pt">
        Hi! Thanks for your interest to join Stix' beta. We'll need some basic
        info about you and your company in order to review your application.
      </p>

      <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 10px">
        <div class="mb-4">
          <p class="text-white mb-2" style="font-size: 12px">First name</p>
          <v-text-field
            variant="solo"
            v-model="first_name"
            flat
            bg-color="smoke"
            label="First name"
            hide-details=""
            style="border-radius: 6px"
          ></v-text-field>
        </div>
        <div class="mb-4">
          <p class="text-white mb-2" style="font-size: 12px">Last name</p>
          <v-text-field
            variant="solo"
            v-model="last_name"
            flat
            bg-color="smoke"
            label="Last name"
            hide-details=""
            style="border-radius: 6px"
          ></v-text-field>
        </div>
      </div>

      <div class="mb-4">
        <p class="text-white mb-2" style="font-size: 12px">Work email:</p>
        <v-text-field
          variant="solo"
          v-model="email"
          flat
          bg-color="smoke"
          label="name@company.com"
          hide-details=""
          style="border-radius: 6px"
        ></v-text-field>
      </div>
      <div class="mb-4">
        <p class="text-white mb-2" style="font-size: 12px">
          Your company's website:
        </p>
        <v-text-field
          variant="solo"
          flat
          v-model="website"
          hide-details=""
          bg-color="smoke"
          label="www.yourcompany.com"
          style="border-radius: 6px"
        ></v-text-field>
      </div>

      <div class="mb-4">
        <p class="text-white mb-2" style="font-size: 12px">
          How big is your company?
        </p>
        <v-select
          variant="solo"
          flat
          hide-details=""
          bg-color="smoke"
          label="Company size"
          style="border-radius: 6px"
          :items="company_sizes"
          v-model="company_size"
        >
        </v-select>
      </div>

      <div class="mb-4">
        <p class="text-white mb-2" style="font-size: 12px">
          How experienced are you with social media management?
        </p>
        <v-select
          variant="solo"
          flat
          hide-details=""
          bg-color="smoke"
          label="Experience"
          style="border-radius: 6px"
          :items="experience_options"
          v-model="experience"
        >
        </v-select>
      </div>

      <div class="mb-4">
        <p class="text-white mb-2" style="font-size: 12px">
          What features do you use most?
        </p>
        <v-select
          variant="solo"
          flat
          bg-color="smoke"
          label="Features"
          style="border-radius: 6px"
          hide-details=""
          multiple=""
          :items="features_options"
          v-model="features"
        >
        </v-select>
      </div>

      <div class="mb-4">
        <p class="text-white mb-2" style="font-size: 12px">
          What platforms do you (intend to) publish posts?
        </p>
        <v-select
          variant="solo"
          flat
          bg-color="smoke"
          label="Platforms"
          style="border-radius: 6px"
          hide-details=""
          multiple=""
          :items="platform_options"
          v-model="platforms"
        >
        </v-select>
      </div>

      <div class="mb-4">
        <p class="text-white mb-2" style="font-size: 12px">
          What best describes your role?
        </p>
        <v-select
          variant="solo"
          flat
          bg-color="smoke"
          label="Role"
          style="border-radius: 6px"
          hide-details=""
          :items="role_options"
          v-model="role"
        >
        </v-select>
      </div>

      <v-alert
        width="100%"
        class="mb-4"
        v-if="error"
        type="info"
        style="font-size: 10pt; padding: 5% 5%"
        text="This email has already een registered on the waiting list."
      ></v-alert>

      <v-btn
        @click="add"
        height="48"
        :loading="sending"
        block
        color="accent"
        class="mt-8 primary--text"
        >Join waiting list</v-btn
      >
    </div>
    <div style="margin-top: 100px">
      <v-img
        width="100"
        max-height="40"
        contain
        :src="require('@/assets/logo/logo-white.svg')"
      ></v-img>
    </div>
  </div>
</template>

<script>
import { doc, addDoc, updateDoc, collection } from "firebase/firestore";
import { db } from "@/firebase";
import { httpsCallable } from "firebase/functions";
import { functions } from "@/firebase";

export default {
  data() {
    return {
      sending: false,
      company_size: null,
      company_sizes: ["Just me", "2 - 10", "11 - 50", "51 - 200", "200+"],
      email: "",
      error: false,
      experience: null,
      experience_options: [
        "None or little experience",
        "Familiar with social media tools.",
      ],
      features: [],
      features_options: [
        "Post recycling",
        "AI content generation",
        "Feed overview",
        "Mobile app/website",
        "Scheduling",
        "Analytics",
        "Multi-account management",
        "Team collaboration",
        "Hashtag suggestions",
        "Content calendar",
        "Canva integration",
        "Content ideas library",
      ],
      first_name: "",
      last_name: "",
      industry: null,
      industry_options: [
        "Software & Services (e.g. SaaS)",
        "Agency (Advertising, Marketing, Design)",
        "Professional Services",
        "E-Commerce, Retail and Consumer Goods",
        "Consumer Apps and Media",
        "Healthcare",
        "Consumer Services",
        "Education",
        "Other",
      ],
      platforms: [],
      platform_options: [
        "Facebook",
        "Instagram",
        "Twitter",
        "TikTok",
        "LinkedIn",
        "Snapchat",
        "Pinterest",
        "YouTube",
      ],
      role: null,
      role_options: [
        "Founder / CEO",
        "Customer Success / Support",
        "Sales",
        "Design",
        "Product / Engineering",
        "Marketing",
        "Human Resources",
        "Other",
      ],
      success: false,
      website: "",
    };
  },
  methods: {
    async add() {
      this.sending = true;

      if (!this.email) {
        alert("Email field is empty.");
        this.sending = false;
        return;
      } else {
        const emailUsed = httpsCallable(functions, "emailUsed");
        const res = await emailUsed({
          email: this.email,
        });

        console.log(res);
        if (res.data) {
          this.error = true;
          this.sending = false;
          return;
        } else {
          let user = {
            first_name: this.first_name,
            last_name: this.last_name,
            email: this.email,
            company_size: this.company_size,
            company_website: this.website,
            role: this.role,
            company_industry: this.industry,
            platforms: this.platforms,
            approved: false,
            experience: this.experience,
            features: this.features,
            timestamp: Math.floor(Date.now() / 1000),
            workspace: null,
            user: null,
            active: true,
            status: "signed_up",
          };

          const docRef = await addDoc(collection(db, "waiting_list"), user);

          await updateDoc(doc(db, "waiting_list", docRef.id), {
            uid: docRef.id,
          });
          this.success = true;

          const email = httpsCallable(functions, "email");
          await email({
            email: this.email,
            template: {
              name: "waiting_list_confirmation",
              data: {},
            },
          });
          this.sending = false;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.formcontainer {
  height: 100%;
  width: 100vw;
  margin: 0;
  display: flex;
  flex-direction: column;
  text-align: center;
  align-items: center;
  padding-bottom: 100px;

  .center {
    max-width: 400px;
  }
}
</style>
